// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footerBtn":"Footer_footerBtn__6rWD5","footerBtnText":"Footer_footerBtnText__lNT0d"};